import * as React from "preact";
import { render } from "preact";

import utils from "../../helpers/utils";
import App from "./App";

function init(): void {
  const el = document.getElementById("search-app");
  const elBox = document.getElementById("search-app-box");
  const searchAppBlocks = document.querySelectorAll<HTMLElement>('.js-search-app-block');

  if (el) {
    const { apiUrl, filtersApiUrl, searchBoxOnly, settings, recentSearchApiUrl } = el.dataset;
    render(
      <App
        apiUrl={apiUrl}
        filtersApiUrl={filtersApiUrl}
        recentSearchApiUrl={recentSearchApiUrl}
        searchBoxOnly={utils.isStringTrue(searchBoxOnly)}
        settings={settings && JSON.parse(settings)}
        id="searchApp"
        // Key used to force this entire app to render again as if "new" when re-initialised, rather than keeping old state such as role/region from
        // a previous time this modal was opened More info:
        // https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state Related bug:
        // https://quilter.atlassian.net/secure/RapidBoard.jspa?rapidView=8&projectKey=PW&modal=detail&selectedIssue=PW-1529
        key={new Date().getTime()}
      />,
      el,
    );
  }
  if (elBox) {
    const { searchBoxOnly, settings, recentSearchApiUrl } = elBox.dataset;
    render(
      <App
        searchBoxOnly={utils.isStringTrue(searchBoxOnly)}
        recentSearchApiUrl={recentSearchApiUrl}
        settings={settings && JSON.parse(settings)}
        id="searchAppBox"
        // Key used to force this entire app to render again as if "new" when re-initialised, rather than keeping old state such as role/region from
        // a previous time this modal was opened More info:
        // https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state Related bug:
        // https://quilter.atlassian.net/secure/RapidBoard.jspa?rapidView=8&projectKey=PW&modal=detail&selectedIssue=PW-1529
        key={new Date().getTime()}
      />,
      elBox,
    );
  }

  if (!searchAppBlocks.length) return;

  searchAppBlocks.forEach(searchAppBlock =>
  {

    const id = searchAppBlock.id;
    const appBlock = document.getElementById(id);

    if (appBlock) {
      const { settings, recentSearchApiUrl } = appBlock.dataset;
      render(
        <App
          id={id}
          searchBoxOnly={true}
          recentSearchApiUrl={recentSearchApiUrl}
          inStandalonePageBlock={true}
          settings={settings && JSON.parse(settings)}
          // Key used to force this entire app to render again as if "new" when re-initialised, rather than keeping old state such as role/region
          // from a previous time this modal was opened More info:
          // https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state Related bug:
          // https://quilter.atlassian.net/secure/RapidBoard.jspa?rapidView=8&projectKey=PW&modal=detail&selectedIssue=PW-1529
          key={new Date().getTime()}
        />,
        appBlock,
      );
    }
  });
}

export default { init };
